import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

const PacientesView = lazy(() => import('../../container/clinica/pacientes/Index'));
const PacientesFormContainer = lazy(() => import('../../container/clinica/pacientes/FormContainer'));
const PacienteExpediente = lazy(() => import('../../container/clinica/pacientes/PacienteExpediente'));
const HistorialClinicoView = lazy(() => import('../../container/clinica/pacientes/HistorialClinico'));
const Agenda = lazy(() => import('../../container/clinica/pacientes/Agenda'));
const CajaView = lazy(() => import('../../container/clinica/caja/Caja'));
const MembresiasView = lazy(() => import('../../container/clinica/membresia/Index'));
const FichaMedicaView = lazy(() => import('../../container/clinica/pacientes/FichaMedica'));
const PresupuestoView = lazy(() => import('../../container/clinica/pacientes/Presupuesto'));
const CorteCajaView = lazy(() => import('../../container/clinica/caja/CorteCajaMenu'));

const ClinicaRoute = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/clinica/pacientes/listado`} component={PacientesView} />    
      <Route path={`${path}/clinica/pacientes/form`} component={PacientesFormContainer} />
      <Route exact path={`${path}/clinica/pacientes/editar/:id`} component={PacientesFormContainer} />      
      <Route exact path={`${path}/clinica/pacientes/expediente/:id`} component={PacienteExpediente} />      
      <Route exact path={`${path}/clinica/pacientes/expediente/historial-clinico/:id`} component={HistorialClinicoView} />     
      <Route exact path={`${path}/clinica/caja/:id`} component={CajaView} />             
      <Route exact path={`${path}/clinica/pacientes/expediente/membresia/:id`} component={MembresiasView} />     
      <Route exact path={`${path}/clinica/pacientes/expediente/ficha-medica/:id`} component={FichaMedicaView} />     
      <Route path={`${path}/clinica/agenda`} component={Agenda} />    
      <Route exact path={`${path}/clinica/pacientes/expediente/presupuesto/:id`} component={PresupuestoView} />                 
      <Route path={`${path}/clinica/corte-del-dia`} component={CorteCajaView} />    
    </Switch>
  );
};

export default ClinicaRoute;
